// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iO2q","right":"styles_right__2SxLA"};